if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form) {
          document.addEventListener("DOMContentLoaded", () => {
            this.form.querySelector("[name=id]").disabled = false;
          });
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          console.warn("Form with ID #product-form not found.");
        }

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      getVariantPickerEl() {
        const sectionId = this.dataset.source;
        if (!sectionId) return null;
        return document.getElementById(`variant-picker-${sectionId}`);
      }

      getVariantsFromPickerScript() {
        const picker = this.getVariantPickerEl();
        if (!picker) return null;
        const el = picker.querySelector("[data-all-variants-no-high]");
        if (!el) return null;
        try {
          const parsed = JSON.parse(el.textContent.trim());
          return Array.isArray(parsed) ? parsed : null;
        } catch {
          return null;
        }
      }

      /**
       * When the full variant list is on the page (not high-variant truncated JSON),
       * block add-to-cart if the hidden id was tampered with or is sold out / unavailable.
       */
      isSubmittedVariantClientAllowed(formData) {
        const variantIdRaw = formData.get("id");
        if (!variantIdRaw) {
          this.handleErrorMessage(
            window.variantStrings?.invalidVariant || "Invalid selection."
          );
          return false;
        }
        const variantId = String(variantIdRaw).trim();

        const picker = this.getVariantPickerEl();
        if (picker && picker.dataset.isHighVariantProduct === "true") {
          return true;
        }

        const variants = this.getVariantsFromPickerScript();
        if (!variants || variants.length === 0) {
          return true;
        }

        const match = variants.find((v) => String(v.id) === variantId);
        if (!match) {
          this.handleErrorMessage(
            window.variantStrings?.invalidVariant ||
              "This selection is not valid for this product."
          );
          return false;
        }
        if (match.available === false) {
          this.handleErrorMessage(
            window.variantStrings?.soldOut ||
              window.variantStrings?.unavailable ||
              "Unavailable"
          );
          return false;
        }
        return true;
      }

      formatCartErrorDescription(description) {
        if (description == null) return "";
        if (typeof description === "string") return description;
        if (Array.isArray(description)) {
          return description
            .map((d) =>
              typeof d === "string" ? d : this.formatCartErrorDescription(d)
            )
            .filter(Boolean)
            .join(" ");
        }
        if (typeof description === "object") {
          return Object.values(description)
            .map((v) => this.formatCartErrorDescription(v))
            .filter(Boolean)
            .join(" ");
        }
        return String(description);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        if (!this.isSubmittedVariantClientAllowed(formData)) {
          return;
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // dispatch cart:error
              document.dispatchEvent(
                new CustomEvent("cart:error", {
                  detail: {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.description,
                    message: response.message,
                  },
                })
              );

              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              const errText =
                this.formatCartErrorDescription(response.description) ||
                response.message ||
                window.cartStrings?.error;
              this.handleErrorMessage(errText);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // dispatch variant:add when fetch fail
            document.dispatchEvent(
              new CustomEvent("variant:add", {
                detail: {
                  variant: {
                    id: formData.get("id"),
                  },
                  quantity: Number(formData.get("quantity") || 1),
                  formElement: this.form,
                  sectionId: this.dataset.source,
                },
              })
            );

            fetch(`${routes.cart_url}.js`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);

                // dispatch cart:change for the entire basket
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    detail: {
                      cart: parsedState,
                      sectionId: this.dataset.source,
                    },
                  })
                );
              })
              .catch((error) => {
                console.error("Error fetching cart state:", error);
              });

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
